import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import { KET_EXAM_TYPE_MOCK, KET_EXAM_TYPE_REAL } from 'data/KetExams';

import KetExam, { MOCK_EXAM_COUNT, DEFAULT_MOCK_INDEX } from './component';
import ListView from './ListView';
import MarkView from './MarkView';

const isAccessable = (state, groupId, tabCode) =>
  PrivilegeChecker.hasPrivilege(state, Privileges.ProgressTest.View) &&
  TabSwitcher.isTabEnabled(state, groupId, tabCode);

const mockExamSecondLevelTabs = ({ push, params, buildRoute }) => {
  const { groupId, mockIndex } = params;
  const activeIndex = mockIndex || DEFAULT_MOCK_INDEX;
  const tabs = [];
  for (let index = 1; index <= MOCK_EXAM_COUNT; index += 1) {
    tabs.push({
      text: `MOCK EXAM ${index}`,
      onClick: () => push(buildRoute(`/group/${groupId}/ket-exam/${index}`)),
      isActive: `${activeIndex}` === `${index}`,
    });
  }
  return tabs;
};

const createKetExamRoutes = ({ getState, examType, path, tabCode, label, order }) => ({
  path,
  component: KetExam,
  examType,
  canAccess: ({ params }) => isAccessable(getState(), params.groupId, tabCode),
  tab: {
    label,
    order,
    isVisible: (params) => isAccessable(getState(), params.groupId, tabCode),
  },
  ...(examType === KET_EXAM_TYPE_MOCK ?
    { secondLevelTabs: mockExamSecondLevelTabs } :
    {}),
  indexRoute: {
    component: ListView,
  },
  childRoutes: examType === KET_EXAM_TYPE_MOCK ?
  [
      { path: ':mockIndex', component: ListView },
      { path: ':mockIndex/student/:studentId', component: MarkView },
  ] :
  [
      { path: 'student/:studentId', component: MarkView },
  ],
});

export const ketMockExamRoutes = ({ getState }) => createKetExamRoutes({
  getState,
  examType: KET_EXAM_TYPE_MOCK,
  path: 'ket-exam',
  tabCode: TabCodes.KETMockExam,
  label: 'Exam',
  order: 1,
});

export const ketScoreRoutes = ({ getState }) => createKetExamRoutes({
  getState,
  examType: KET_EXAM_TYPE_REAL,
  path: 'ket-score',
  tabCode: TabCodes.KETScore,
  label: 'KET RESULTS',
  order: 2,
});



// WEBPACK FOOTER //
// ./containers/Group/KetExam/routes.js